<template>
  <div id="scenario" class="col-12 p-0">
    <div>
      <!-- Modal crear y editar -->
      <FormModal :id="idFormModal" :title="formModalTitle">
        <scenario-form
          ref="scenario_form"
          @guardar="abrirConfirModal"
          @cancelar="$bvModal.hide(idFormModal)"
          @eliminar="abrirConfirDelModal"
          :loadingSave="loadingLineDeals"
          :textDel="titulo"
        />
      </FormModal>

      <!-- Confirmar editar, crear y eliminar  -->
      <ComfirmModal
        :id="idConfirModal"
        :title="eliminarRegistro ? confirmDelModalTitle : confirmModalTitle"
        :size="eliminarRegistro ? 'md' : 'lg'"
        variantAlert="warning"
        :textAlert="textAlertModal"
        :iconAlert="true"
        :eliminarRegistro="eliminarRegistro"
      >
        <scenario-show
          @guardar="guardar"
          @editar="editar"
          @cancelar="cancelar"
          @eliminar="eliminar"
          :formulario="this.$refs.scenario_form"
          :loadingSave="loading"
          :loadingEdit="loading"
          :loadingDel="loading"
          :loadingPrevius="loading"
          :eliminarRegistro="eliminarRegistro"
          :textDel="titulo"
        />
      </ComfirmModal>

      <!-- 3 MODAL -- EXITOSO  -->
      <InfoModal
        :id="idInfoModal"
        :title="titleInfo"
        :content="
          error
            ? typeof error === 'object'
              ? 'Error consultando los datos'
              : error
            : message
        "
        :status="
          error ? (typeof error === 'object' ? 'danger' : 'danger') : 'success'
        "
        @entendido="$bvModal.hide(idInfoModal)"
      />
    </div>
    <div class="row">
      <SelectSettings />
      <!-- Boton Crear Escenario -->
      <div class="col-lg-4 col-sm-12 mt-4">
        <AddCategory text="Agregar Escenario +" @nuevo="nuevo" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="mb-4 card-personalizada">
          <div class="card-header card-header-left">
            <h3 style="color:color: #263238;">Lista de {{ titulo }}</h3>
          </div>
          <div class="col-12">
            <SearchTable
              @buscar="finishTipyng"
              :title="titulo"
              :delay="delay"
            />
          </div>

          <div class="col-12 d-flex flex-column align-items-center">
            <ScenarioDatatable
              class="col-12 d-flex flex-column align-items-center my-0 py-0"
              @ver="ver"
              @paginar="getFilterDp"
              :scenarios="scenarios"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SelectSettings from "@/components/platformSettings/selectSettings.vue";
import FormModal from "@/components/core/modal/form-modal.vue";
import ComfirmModal from "@/components/core/modal/confirm-modal.vue";
import InfoModal from "@/components/core/modal/info-modal.vue";
import SearchTable from "@/components/core/search/search-table.vue";
import AddCategory from "@/components/core/button/add-category.vue";
import ScenarioForm from "./scenarios/scenario-form.vue";
import ScenarioShow from "./scenarios/scenario-show.vue";
import ScenarioDatatable from "./scenarios/scenario-datatable.vue";

export default {
  name: "LineBusiness",
  components: {
    SelectSettings,
    InfoModal,
    FormModal,
    ComfirmModal,
    SearchTable,
    AddCategory,
    ScenarioForm,
    ScenarioShow,
    ScenarioDatatable,
  },
  data() {
    return {
      titulo: "Escenario",
      idFormModal: "modal-create-edit",
      idConfirModal: "modal-confir-create-edit",
      idInfoModal: "modal-info",
      eliminarRegistro: false,
      runTime: null,
      datatable: {
        fields: [],
        total: null,
        filter: "",
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      },
      delay: 1000,
    };
  },
  computed: {
    ...mapState("modScenarios", [
      "scenario",
      "scenarios",
      "scenarioselected",
      "loading",
      "loadingLineDeals",
      "lineDeals",
      "error",
      "message",
      "history",
      "cargos",
    ]),

    titleInfo() {
      return this.error ? "¡Error!" : "¡Proceso exitoso!";
    },

    formModalTitle: function () {
      return this.scenario.id == null
        ? "Agregar " + this.titulo
        : "Editar " + this.titulo;
    },

    labelGuardarModificar: function () {
      return this.scenario.id == null ? "guardar" : "modificar";
    },

    confirmDelModalTitle: function () {
      return "¿Estás seguro de eliminar '" + this.scenario.name + "'?";
    },

    confirmModalTitle: function () {
      return (
        "¿Estás seguro de " +
        this.labelGuardarModificar +
        " este " +
        this.titulo +
        "?"
      );
    },

    textAlertModal: function () {
      return (
        "Por favor verifica la siguiente información antes de " +
        this.labelGuardarModificar +
        " este " +
        this.titulo +
        "."
      );
    },
  },
  beforeMount() {
    this.inicializarTabla();
    this.loadRows();
    this.obtenerLineasDeNegocio();
    this.actGetCargos();
  },

  methods: {
    ...mapActions("modScenarios", [
      "actSetScenario",
      "actLineDeals",
      "actScenarios",
      "actSaveScenario",
      "actUpdateScenario",
      "actDeleteScenario",
      "actGetCargos",
    ]),

    inicializarTabla() {
      this.datatable.fields = [
        {
          label: "Escenario",
          key: "name",
          sortable: true,
        },
        {
          label: "Sub-Escenarios",
          key: "id",
          sortable: true,
        },
        {
          label: "Cargos asociados",
          key: "line_deal.id",
          sortable: true,
        },
        {
          label: "Línea de Negocio",
          key: "line_deal.name",
          sortable: true,
        },
      ];
    },

    loadRows() {
      let filtros = {
        page: this.datatable.page,
        filter: this.datatable.filter,
      };
      this.actScenarios(filtros);
    },

    obtenerLineasDeNegocio() {
      let filter = {
        filter: "filter/false",
      };
      this.actLineDeals(filter);
    },

    cancelar() {
      this.$root.$emit("bv::hide::modal", this.idConfirModal);
      this.$root.$emit("bv::show::modal", this.idFormModal);
    },

    nuevo() {
      this.actSetScenario({ id: null, name: null, sub_scenarios: [] });
      this.$root.$emit("bv::show::modal", this.idFormModal);
    },

    ver(row) {
      this.actSetScenario(row);
      this.$root.$emit("bv::show::modal", this.idFormModal);
    },

    guardar() {
      this.actSaveScenario(this.scenario)
        .then(() => {
          this.$root.$emit("bv::hide::modal", this.idConfirModal);
          this.$root.$emit("bv::show::modal", this.idInfoModal);
          this.loadRows();
        })
        .catch(() => {
          this.$root.$emit("bv::hide::modal", this.idConfirModal);
          this.$root.$emit("bv::show::modal", this.idInfoModal);
          this.loadRows();
        });
    },

    editar() {
      this.actUpdateScenario(this.scenario)
        .then(() => {
          this.$root.$emit("bv::hide::modal", this.idConfirModal);
          this.$root.$emit("bv::show::modal", this.idInfoModal);
          this.loadRows();
        })
        .catch(() => {
          this.$root.$emit("bv::hide::modal", this.idConfirModal);
          this.$root.$emit("bv::show::modal", this.idInfoModal);
          this.loadRows();
        });
    },

    eliminar() {
      this.actDeleteScenario(this.scenario.id)
        .then(() => {
          this.$root.$emit("bv::hide::modal", this.idConfirModal);
          this.$root.$emit("bv::show::modal", this.idInfoModal);
          this.loadRows();
        })
        .catch(() => {
          this.$root.$emit("bv::hide::modal", this.idConfirModal);
          this.$root.$emit("bv::show::modal", this.idInfoModal);
          this.loadRows();
        });
    },

    abrirConfirModal() {
      this.eliminarRegistro = false;
      this.$root.$emit("bv::hide::modal", this.idFormModal);
      this.$root.$emit("bv::show::modal", this.idConfirModal);
    },

    abrirConfirDelModal() {
      this.eliminarRegistro = true;
      this.$root.$emit("bv::hide::modal", this.idFormModal);
      this.$root.$emit("bv::show::modal", this.idConfirModal);
    },

    getFilterDp(page = 1) {
      this.datatable.page = page;
      this.loadRows();
    },

    finishTipyng(filtro = "") {
      this.datatable.filter = filtro;
      this.getFilterDp();
    },
    limpiarEstadoScenario() {
      let scenario = {
        id: null,
        sub_scenarios: [],
      };
      this.actSetScenario(scenario);
    },
  },
  /*errorCaptured: function (err) {
    console.log("Level 1 error", err);
    return true;
  },*/
};
</script>
<style lang="scss">
#scenario {
  .buscar-empleado {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;

    position: relative;
    width: 428px !important;
    height: 44px;
    //left: 30px;
    top: calc(50% - 44px / 2);
    margin-bottom: 24px;

    background: #ffffff;
    /* content/03 */

    border: 1px solid #b0bec5;
    border-radius: 22px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 16px 0px;
  }
  .buscar-empleado .form-control {
    border: 0px !important;
    font-family: Ubuntu !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 16px !important;
    line-height: 28px !important;
  }

  .card-header-left {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    border-bottom: none;

    widows: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .card-header-text {
    /* Header Tablas */

    font-style: normal;
    //background: #F5F5F5;
    font-size: 16px;
    /* identical to box height */
    /* Alert/Succes */
    color: #263238 !important;
    width: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }
  .card-personalizada {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    position: static;
    background: #ffffff;
    border: 0px solid #eceff1 !important;
    box-sizing: border-box;
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 12px !important;
    flex: none;
    order: 0;
    flex-grow: 0;
    //margin: 24px 0px;
  }

  /*select.custom-select {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }*/

  .table-views {
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 8px;
    padding: 0;
    margin: 30px 5px;
    .t-head {
      background-color: #f5f5f5;
      padding: 5px 15px;
      text-align: left;
    }
    input {
      padding: 10px 10px;
      font-size: 15px;
      height: 50px;
      border-radius: 10px;
    }
    thead tr {
      background-color: #eef2fa;
      border-radius: 10px;
      text-align: left;
    }
    .theading {
      padding: 15px 15px;
    }
    tbody tr {
      border-radius: 10px;
    }
    tbody tr td {
      padding: 15px 15px;
      cursor: pointer;
    }
    tbody tr:hover {
      background-color: #f5f5f5;
    }
  }
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none !important;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none !important;
}

.was-validated .custom-select:invalid,
.custom-select.is-invalid {
  background-image: none !important;
}

.was-validated .custom-select:valid,
.custom-select.is-valid {
  background-image: none !important;
}

.valid-feedback {
  color: #00761a;
}

.invalid-feedback {
  color: #ac0000;
}
</style>